import React from 'react';
import styled from '@emotion/styled';

export const BlockQuote = styled.blockquote`
  margin: 0;
`;
